import { usePathSavedSearch } from 'hooks';
import { useNavigate } from 'react-router-dom';
import { Button, FlexContainer, Icon, Txt } from 'components';
import styles from './AuthHome.module.scss';

/**
 * AuthHomeScreen
 *
 * @return {JSX.Element}
 */
const AuthHome = () => {
  const navigate = useNavigate();
  const createPathWithSearch = usePathSavedSearch();
  const regPath = createPathWithSearch('registration');
  const loginPath = createPathWithSearch('login');

  const handleRegistration = () => navigate(regPath);
  const handleLogin = () => navigate(loginPath);

  return (
    <FlexContainer
      className={styles.Container}
      justifyContentCenter
      column
      flex
      gap
    >
      {/*<iframe src="https://propa-app-page.webflow.io/" />*/}
      <FlexContainer column gapHalf>
        <Txt xxxxx>Welcome to Propa 🏡</Txt>
        <Txt xx regular>
          Create an account, or if you already have one Login.
        </Txt>
      </FlexContainer>
      <Button onClick={handleRegistration} success big>
        <FlexContainer flex spaceBetween alignCenter>
          <Txt xx>Create an account</Txt>
          <Icon name="goto" />
        </FlexContainer>
      </Button>
      <Button onClick={handleLogin} big>
        <FlexContainer flex spaceBetween alignCenter>
          <Txt xx>Login</Txt>
          <Icon name="goto" />
        </FlexContainer>
      </Button>
    </FlexContainer>
  );
};

AuthHome.displayName = 'AuthHomeScreen';

export default AuthHome;
